// extracted by mini-css-extract-plugin
module.exports = {"info":"styles-m__info---2kKM5","notification":"styles-m__notification---1Pgm1"};